import { useMemo } from 'react'
import { Link, useLocation } from 'react-router'
import { aSelectedListing, useSetAtom } from '~/atoms'
import { Tabs } from '~/components/ui'

export default function MapNavigationTabs() {
  const location = useLocation()
  const setSelectedListing = useSetAtom(aSelectedListing)

  const currentView = useMemo(() => {
    if (location.pathname.startsWith('/cards')) {
      return 'Cards'
    }
    return 'Map'
  }, [location])

  return (
    <div className="rounded-md shadow-md">
      <Tabs value={currentView}>
        <Tabs.List className="bg-background">
          <Tabs.Trigger
            asChild
            value="Map"
            className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <Link id="nav-map" to={`/${location.search}`}>
              Map
            </Link>
          </Tabs.Trigger>
          <Tabs.Trigger
            asChild
            value="Cards"
            className="data-[state=active]:bg-primary data-[state=active]:text-white">
            <Link
              id="nav-cards"
              to={`/cards${location.search}`}
              onClick={() => {
                setSelectedListing(null)
              }}>
              Cards
            </Link>
          </Tabs.Trigger>
        </Tabs.List>
      </Tabs>
    </div>
  )
}
